import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate } from "react-router";

import { $api } from "@/lib/api";
import { routePaths } from "@/router/route-paths";

interface ApiError {
  statusCode: number;
}

export const useUser = () => {
  const navigate = useNavigate();
  const { user: auth0User, isAuthenticated } = useAuth0();

  const enabled = isAuthenticated;

  const {
    data: user,
    failureReason,
    isLoading,
  } = $api.useQuery("get", "/v1/users/me", {}, { enabled });

  // Handle 403 Forbidden - user doesn't have customer access
  useEffect(() => {
    const apiError = failureReason as unknown as ApiError | undefined;

    if (apiError?.statusCode === 403) {
      void navigate(routePaths.logout);
    }
  }, [failureReason, navigate]);

  // `isLoading` is true only while the enabled /me query is in flight (it is
  // false for the disabled, unauthenticated query). Consumers gate ability-
  // dependent UI on it so they never decide access against a not-yet-loaded
  // ability — see MainLayout (P-2226).
  return { user, auth0User, isLoading };
};
